module.exports = __webpack_public_path__ + "static/media/F23_2.9e6d89b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/wounds/F23_2.png
// module id = 2238
// module chunks = 0